// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop" + "_" + "4d206c48f6eee81e4739" + ".css";
};